import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { rolesdef } from '@app/constants/role-def';
import { AuthenticationService } from '@app/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-system',
  standalone: false,
  templateUrl: './system.component.html',
  styleUrls: ['./system.component.scss']
})
export class SystemComponent implements OnInit, OnDestroy {
  public router: Router;
  activeTabIndex = 0;
  private sub: Subscription | undefined;
  public role: string;
  public roles: any;

  constructor(router: Router, private route: ActivatedRoute, private authService: AuthenticationService) {
    this.role = this.authService.authenticatedRoleCd;
    this.router = router;
  }

  ngOnInit() {
    this.roles = rolesdef;
    // sync initial state
    this.syncTabWithUrl(this.router.url);
    // update on navigation
    this.sub = this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
      this.syncTabWithUrl(e.urlAfterRedirects || e.url);
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  get isEndUser(): boolean {
    return this.role === rolesdef.enduser;
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index;
    const route = this.getRouteForTabIndex(this.activeTabIndex);
    if (route) {
      this.router.navigate([route], { relativeTo: this.route });
    }
  }

  private getRouteForTabIndex(index: number): string | null {
    if (this.isEndUser || this.role === rolesdef.installer) {
      // Tabs: [App Configuration, Group Management, Device Access Management]
      switch (index) {
        case 0: return 'appconfiguration';
        case 1: return 'groups-management';
        case 2: return 'device-access-management';
        default: return null;
      }
    } else {
      // Tabs: [App Configuration, User Management, Group Management, Device Access Management]
      switch (index) {
        case 0: return 'appconfiguration';
        case 1: return 'users-management';
        case 2: return 'groups-management';
        case 3: return 'device-access-management';
        default: return null;
      }
    }
  }

  private syncTabWithUrl(url: string) {
    if (url.includes('/device-access-management')) {
      this.activeTabIndex = this.isEndUser || this.role === rolesdef.installer ? 2 : 3;
    } else if (url.includes('/users-management') && !this.isEndUser && this.role !== rolesdef.installer) {
      this.activeTabIndex = 1;
    } else if (url.includes('/groups-management')) {
      this.activeTabIndex = this.isEndUser || this.role === rolesdef.installer ? 1 : 2;
    } else {
      this.activeTabIndex = 0;
    }
  }
}
